import React, { useState, useEffect } from "react";
import { Col, Row ,Card} from "reactstrap";
import { FilterMatchMode } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import moment from "moment";
import { Skeleton } from "primereact/skeleton";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { useNavigate } from "react-router-dom";
import { getStationWiseData } from "./API/Api";
import "./CSS/StationWiseData.css";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import Select from "react-select";
import WidgetInfo from "./WidgetInfo";
import _ from "underscore";
import { Calendar } from "primereact/calendar";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import LineChart from "./LineChart";

const StationWiseData = () => {
  const [StationWiseData, setStationWiseData] = useState();
  const [loading, setLoading] = useState(true);
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [date, setDate] = useState([
    moment().startOf("month").toDate(),
    moment().toDate(),
  ]);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [lazyLoading, setLazyLoading] = useState(true);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(1);
  const [dropDownItem, setDropDownItem] = useState();
  const [selectedModel, setSelectedModel] = useState();
  const [selectedShift, setSelectedShift] = useState();
  const [displayAllData, setDisplayAllData] = useState(false);
  const [originalData, setOriginalData] = useState(StationWiseData);
  const [filteredData, setFilteredData] = useState(StationWiseData);
  const navigate = useNavigate();
  const [chartData, setChartData] = useState();

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [arrStations, setArrStations] = useState([
    {
      label: "EBM",
      value: "K#EBM",
    },
    {
      label: "UBS",
      value: "K#UBS",
    },
    {
      label: "CSS",
      value: "K#CSS",
    },
    {
      label: "ALL",
      value: "K#ALL",
    },
  ]);

  const [arrShifts, setArrShifts] = useState([
    {
      label: "I",
      value: "I",
    },
    {
      label: "II",
      value: "II",
    },
    {
      label: "III",
      value: "III",
    },
  ]);

  const [arrModel, setArrModel] = useState([
    {
      label: "Z101",
      value: "Z101",
    },
    {
      label: "W601",
      value: "W601",
    },
  ]);
  const [page_size, setPageSize] = useState(10);
  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderRadius: "16px",
    }),
  };
  const [start_date, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DDT00:00:00[Z]")
  );

  const [end_date, setEndDate] = useState(
    moment().format("YYYY-MM-DDT23:59:59[Z]")
  );
  const [showAccessDenied, setShowAccessDenied] = useState(true);
  const [statusCount, setStatusCount] = useState(0);
  const [lastEvaluatedKey, setLastEvaluatedKey] = useState({});

  // const loadCarsLazy = (event) => {
  //   setFirst(event.first);

  //   fetchData(
  //     dropDownItem?.value,
  //     start_date,
  //     end_date,
  //     page_size,
  //     lastEvaluatedKey
  //   );
  // };
 
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = filters ? { ...filters } : {};
    if (value === null) {
      console.log("Value is null");
      return;
    }
    //let _filters = { ...filters };

    _filters["global"].value = value;
    console.log(value);
    setFilters(_filters);
    setGlobalFilterValue(value);
    const updatedFilters = filters ? { ...filters, global: { value } } : {};
    setFilters(updatedFilters);
  };
  const handleModelSort = () => {
    const newSortOrder = sortField === "model" ? -sortOrder : 1;
    setSortField("model");
    setSortOrder(newSortOrder);

    const sorted_data = StationWiseData.slice().sort((a, b) => {
      if (a.model < b.model) return -1 * sortOrder;
      if (a.model > b.model) return 1 * sortOrder;
      return 0;
    });
    setStationWiseData(sorted_data);
  };

  const handleBINSort = () => {
    const newSortOrder = sortField === "bin_no" ? -sortOrder : 1;
    setSortField("bin_no");
    setSortOrder(newSortOrder);

    const sorted_data = StationWiseData.slice().sort((a, b) => {
      if (a.bin_no < b.bin_no) return -1 * sortOrder;
      if (a.bin_no > b.bin_no) return 1 * sortOrder;
      return 0;
    });
    setStationWiseData(sorted_data);
  };

  const handleShiftSort = () => {
    const newSortOrder = sortField === "shift" ? -sortOrder : 1;
    setSortField("shift");
    setSortOrder(newSortOrder);

    const sorted_data = StationWiseData.slice().sort((a, b) => {
      if (a.shift < b.shift) return -1 * sortOrder;
      if (a.shift > b.shift) return 1 * sortOrder;
      return 0;
    });
    setStationWiseData(sorted_data);
  };

  const handleTimeSort = () => {
    const newSortOrder = sortField === "formatted_time" ? -sortOrder : 1;
    setSortField("formatted_time");
    setSortOrder(newSortOrder);

    const sorted_data = StationWiseData.slice().sort((a, b) => {
      if (a.formatted_time < b.formatted_time) return -1 * sortOrder;
      if (a.formatted_time > b.formatted_time) return 1 * sortOrder;
      return 0;
    });
    setStationWiseData(sorted_data);
  };

  const handleDateSort = () => {
    const newSortOrder = sortField === "formatted_date" ? -sortOrder : 1;
    setSortField("formatted_date");
    setSortOrder(newSortOrder);

    const sorted_data = StationWiseData.slice().sort((a, b) => {
      if (a.formatted_date < b.formatted_date) return -1 * sortOrder;
      if (a.formatted_date > b.formatted_date) return 1 * sortOrder;
      return 0;
    });
    setStationWiseData(sorted_data);
  };

  const transformData = (data) => {
    const transformedData = {};

    data.forEach((item) => {
      const key = `${item.formatted_date}-${item.formatted_time}-${item.bin_no}-${item.model}-${item.shift}`;

      if (!transformedData[key]) {
        transformedData[key] = {
          formatted_date: item.formatted_date,
          formatted_time: item.formatted_time,
          bin_no: item.bin_no,
          model: item.model,
          shift: item.shift,
          results: {},
          status: 0,
        };
      }
      if (item.status === 1) {
        transformedData[key].status = 1;
      }
      // Assuming "EBM," "UBS," and "CSS" are the possible values for the 'partition_key'
      const partitionKey = item.partition_key.split("#")[1];
      transformedData[key].results[partitionKey] = {
        status: item.status,
        timestamp: item.timestamp,
        result: item.result,
      };
    });

    // Convert the dictionary to a list
    const outputList = Object.values(transformedData);

    return outputList;
  };

  const fetchData = async (
    station,
    start_date,
    end_date,
    page_size,
    lastEvaluatedKey
  ) => {
    try {
      let allResultItems = [];
      let response;

      do {
        // Check if lastEvaluatedKey is provided
        response = await getStationWiseData(
          station,
          start_date,
          end_date,
          page_size,
          lastEvaluatedKey
        );

        const { last_evaluated_key, result_items } = response;

        // Append the result_items to the allResultItems array
        allResultItems = allResultItems.concat(result_items);

        // Update the lastEvaluatedKey for the next iteration
        lastEvaluatedKey = last_evaluated_key;
      } while (lastEvaluatedKey);

      const { total_records } = response;
      // console.log(response, "hello");

      let bin_no_arr = _.pluck(response.result_items, "bin_no");
      // console.log(bin_no_arr, "hi");

      // let defect_count_arr = _.pluck(response.result_items.result.Parts.defect_count,"defect_count")
      // console.log(defect_count_arr,"defect")

      setTotalRecords(total_records);
      setLastEvaluatedKey(null); // Set lastEvaluatedKey to null since all records are loaded

      const StationWiseData_data = allResultItems.map((item, index) => ({
        ...item,
        serial_number: index + 1,
        formatted_date: moment(item.formatted_date).format("DD/MM/YYYY"),
      }));

      const count = allResultItems.reduce(
        (acc, entry) => (entry.status === 1 ? acc + 1 : acc),
        0
      );

      // Update the state with the count
      setStatusCount(count);

      // If station is "K#ALL", transform the data
      if (station === "K#ALL") {
        const transformedData = transformData(allResultItems);
        const transformedDataWithSerial = transformedData.map(
          (item, index) => ({
            ...item,
            serial_number: index + 1,
            formatted_date: moment(item.formatted_date).format("DD/MM/YYYY"),
          })
        );

        setDisplayAllData(true);
        setStationWiseData(transformedDataWithSerial);
      } else {
        setDisplayAllData(false);
        setStationWiseData(StationWiseData_data);
      }
      let config = {
        series: [
          {
            data: [200, 250, 150, 350, 400, 250, 500, 450, 400, 350, 300],
            name: "Defects",
          },
        ],
        text: "",
        categories: bin_no_arr,
      };
      setChartData(config);
      setLoading(false);
      setLazyLoading(false);
    } catch (error) {
      console.error("Error fetching station-wise data:", error);
    }
  };

  const getStatusColor = (rowData) => {
    return rowData.status === 0 ? "green-cell" : "red-cell";
  };

  const modelFilterFunction = (value, filter) => {
    return value.toLowerCase().includes(filter.toLowerCase());
  };
  const binFilterFunction = (value, filter) => {
    return value.toLowerCase().includes(filter.toLowerCase());
  };

  const shiftFilterFunction = (value, filter) => {
    return value.toLowerCase().includes(filter.toLowerCase());
  };
  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);
  };

  const onChangeDate = (value) => {
    setLazyLoading(true);
    setDate(value);
    let startDate = value[0];
    let endDate = value[1];
    if (startDate !== null && endDate !== null) {
      const formattedStartDate = moment(startDate).format(
        "YYYY-MM-DDTHH:mm:ss[Z]"
      );
      const formattedEndDate = moment(endDate).format("YYYY-MM-DDT23:59:59[Z]");
      setStartDate(formattedStartDate);
      setEndDate(formattedEndDate);
      fetchData(
        dropDownItem?.value,
        formattedStartDate,
        formattedEndDate,
        page_size,
        lastEvaluatedKey
      );
    }
  };

  //
  const handleStationChange = (selectedOption) => {
     setLazyLoading(true);
    setDropDownItem(selectedOption);
    fetchData(
      selectedOption.value,
      start_date,
      end_date,
      page_size,
      lastEvaluatedKey
    );
    sessionStorage.setItem("selectedTitle", selectedOption.label);
  };

  const handleModelChange = (selectedOption) => {
    setSelectedModel(selectedOption);
  };

  const handleShiftChange = (selectedOption) => {
    // console.log("Selected Station:", selectedOption);
    setSelectedShift(selectedOption);
  };

  const onChangeBinNumber = (value) => {};
  const renderStationWiseDataHeaders = () => {
    return (
      <>
        <Row className="mt-3 mx-2 d-flex align-items-center flex-wrap">
          <Col xs={1} md={1} lg={1} xl={1}></Col>
          <Col xs={12} md={4} lg={4} xl={4} className="mb-3">
            <div className="p-input-icon-left">
              <i className="pi pi-search Color" />
              <InputText
                value={globalFilterValue}
                // defaultValue={""}
                onChange={onGlobalFilterChange}
                placeholder="Search BIN"
              />
            </div>
          </Col>
          <Col xs={12} md={1} lg={1} xl={1}></Col>
          <Col xs={12} md={6} lg={6} xl={6} className="mb-3">
            <div className="p-input-icon-left">
              <Calendar
                value={date}
                onChange={(e) => onChangeDate(e.value)}
                selectionMode="range"
                readOnlyInput
                placeholder="Select Date Range"
                className="calendar-input"
                dateFormat="dd/mm/yy"
              />
            </div>
          </Col>
        </Row>
      </>
    );
  };

  const generateViewColumns = (rowData) => {
    let viewColumns = [];

    if (dropDownItem?.value === "K#ALL") {
      viewColumns = [
        <Column
          key={`EBM`}
          field={`results.EBM`}
          header={`EBM`}
          style={{ minWidth: "6rem" }}
          bodyStyle={{ textAlign: "center" }}
          body={(rowData) => verifiedALLStationBodyTemplate(rowData, "EBM")}
        />,
        <Column
          key={`UBS`}
          field={`results.UBS`}
          header={`UBS`}
          style={{ minWidth: "6rem" }}
          bodyStyle={{ textAlign: "center" }}
          body={(rowData) => verifiedALLStationBodyTemplate(rowData, "UBS")}
        />,
        <Column
          key={`CSS`}
          field={`results.CSS`}
          header={`CSS`}
          style={{ minWidth: "6rem" }}
          bodyStyle={{ textAlign: "center" }}
          body={(rowData) => verifiedALLStationBodyTemplate(rowData, "CSS")}
        />,
      ];
    } else {
      viewColumns.push(
        <Column
          key="result"
          field="result"
          header="View"
          style={{ minWidth: "6rem" }}
          bodyStyle={{ textAlign: "center" }}
          body={verifiedBodyTemplate}
        />
      );
    }

    return viewColumns;
  };

  const verifiedBodyTemplate = (rowData) => {
    const isOkayStatus = rowData.status === 0;
    const iconColorClass = isOkayStatus ? "" : "red-color";
    const handleClick = () => {
      // Set rowData in session storage
      sessionStorage.setItem("rowData", JSON.stringify(rowData));
      sessionStorage.setItem("selected_station", dropDownItem.value);
      sessionStorage.setItem("start_date", start_date);
      sessionStorage.setItem("end_date", end_date);
      sessionStorage.setItem("date_range", date);
      // Redirect to the details page
      navigate(
        `/Details?user=${sessionStorage.getItem(
          "user"
        )}&pwd=${sessionStorage.getItem("pwd")}`
      );
    };

    return (
      <>
        <VisibilityOutlinedIcon
          className={`cursor-pointer visibility-icon ${iconColorClass}`}
          onClick={handleClick}
        />
      </>
    );
  };
  const verifiedALLStationBodyTemplate = (rowData, station) => {
    const isOkayStatus = rowData?.results[station]?.status === 0;

    const handleViewIconClick = (rowData, key) => {
      sessionStorage.setItem("rowData", JSON.stringify(rowData));
      sessionStorage.setItem("selected_station", key);
      // Redirect to the details page
      navigate("/Details");
    };
    return (
      <>
        <div>
          {rowData.results[station] ? (
            <VisibilityOutlinedIcon
              className={`cursor-pointer visibility-icon ${
                isOkayStatus ? "" : "red-color"
              }`}
              onClick={() => handleViewIconClick(rowData, station)}
            />
          ) : (
            <>
              <VisibilityOffIcon style={{ color: "#9EA2AD" }} />
            </>
          )}
        </div>
      </>
    );
  };
  const StationWiseData_lot_header = renderStationWiseDataHeaders();
  const loadingTemplate = (options) => {
    return (
      <div className="flex Skeleton align-items-center">
        <Skeleton
          width={
            options.cellEven
              ? options.field === "year"
                ? "30%"
                : "40%"
              : "60%"
          }
          height="1rem"
        />
      </div>
    );
  };

  useEffect(() => {
    let user = sessionStorage.getItem("user");
    let pwd = sessionStorage.getItem("pwd");
    if (user && pwd) {
      setShowAccessDenied(false);
      const data = sessionStorage.getItem("selectedTitle");
      let start_date_from_session = sessionStorage.getItem("start_date");
      let end_date_from_session = sessionStorage.getItem("end_date");
      let selectedDateRangeString = sessionStorage.getItem("date_range");
      if (
        start_date_from_session !== null &&
        end_date_from_session !== null &&
        start_date_from_session !== undefined &&
        end_date_from_session !== undefined
      ) {
        setStartDate(start_date);
        setEndDate(end_date);
        if (selectedDateRangeString != null) {
          let selectedDateRange = selectedDateRangeString
            .split(",")
            .map((dateString) =>
              moment(dateString.trim(), "ddd MMM DD YYYY HH:mm:ss ZZ").toDate()
            );

          setDate(selectedDateRange);
        }
        // setDate([parsedStartDate, parsedEndDate]);
      }
      setDropDownItem({
        label: data,
        value: `K#${data}`,
      });
      fetchData(`K#${data}`, start_date, end_date, page_size, lastEvaluatedKey);
    } else {
      setShowAccessDenied(true);
    }
  }, [start_date, end_date]);
  return (
    <div fluid className="overflow-hidden">
      {showAccessDenied ? (
        <>
          {" "}
          <Row className="justify-content-center text-center">
            <h4 className="access-denied-text">Access Denied</h4>
          </Row>
        </>
      ) : (
        <>
          {/* <Row className="mt-3 mx-4 d-flex align-items-center flex-wrap">
            <Col xs={12} sm={4} md={4} lg={6} xl={6} xxl={3} className="mb-3">
              <Select
                options={arrStations}
                styles={customStyles}
                placeholder="Select"
                className="z-index-high"
                onChange={handleStationChange}
                value={dropDownItem}
              />
            </Col>
            <Col xs={12} sm={6} md={6} lg={6} xl={6} xxl={5} className="mb-3">
              <WidgetInfo station={dropDownItem?.value} count={statusCount} />
            </Col>
            <Col xs={12} sm={2} md={2} lg={6} xl={6} xxl={3} className="mb-3 d-flex Color mx-3 justify-content-end">
               
                <HomeOutlinedIcon
                  style={{ fontSize: "3rem", cursor: "pointer" }}
                  onClick={() => {
                    navigate(`/Home?user=${sessionStorage.getItem(
                      "user"
                    )}&pwd=${sessionStorage.getItem("pwd")}`);
                  }}
                /> 
            </Col>
          </Row> */}

          <Row className="mt-3 mx-2 d-flex align-items-center flex-wrap">
            <Col xs={1} md={1} lg={1} xl={1}></Col>
            <Col xs={12} md={3} lg={3} xl={3} className="mb-3">
              <Select
                options={arrStations}
                styles={customStyles}
                placeholder="Select"
                className="z-index-high"
                onChange={handleStationChange}
                value={dropDownItem}
              />
            </Col>
            <Col xs={12} md={6} lg={6} xl={6} className="mb-3  ">
              <WidgetInfo station={dropDownItem?.value} count={statusCount} />
            </Col>
            <Col
              xs={12}
              md={2}
              lg={2}
              xl={2}
              className="mb-3 d-flex Color justify-content-end text-end"
            >
              <HomeOutlinedIcon
                style={{ fontSize: "3rem", cursor: "pointer" }}
                onClick={() => {
                  navigate(
                    `/Home?user=${sessionStorage.getItem(
                      "user"
                    )}&pwd=${sessionStorage.getItem("pwd")}`
                  );
                }}
              />
            </Col>
          </Row>
          
          {/* <Row className="mx-2 d-flex align-items-center flex-wrap">
            <div className="mx-1">
              {chartData &&
              chartData.series &&
              chartData.series[0]["data"].length !== 0 ? (
                <LineChart config={chartData} />
              ) : (
                <div className="text-center p-5 mt-5 fs-3 mx-1">
                   
                  {chartData &&
                  chartData.series &&
                  chartData.series[0]?.data.length === 0
                    ? "No Data Available"
                    : "Loading..."}
                </div>
              )}
            </div>
          </Row> */}
          <Row className="mx-2 mt-3 d-flex align-items-center flex-wrap ">
            <Col>
              <div>
                {displayAllData ? (
                  <>
                    <DataTable
                      value={StationWiseData}
                      rows={page_size}
                      paginator
                      className="striped-table table-div "
                      dataKey="id"
                      loading={lazyLoading}
                      header={StationWiseData_lot_header}
                      emptyMessage="No data found."
                      scrollable
                      scrollHeight="550px"
                      removableSort
                      globalFilter={globalFilterValue}
                      //globalFilterFields={["bin_no"]}
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      totalRecords={totalRecords}
                      first={first}
                      loadingTemplate={loadingTemplate}
                      // paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    >
                      <Column
                        field="serial_number"
                        header="Sr. No."
                        bodyStyle={{ textAlign: "center" }}
                        style={{ minWidth: "6rem" }}
                      />
                      <Column
                        field="model"
                        header={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                            onClick={handleModelSort}
                          >
                            <span className="table-headers">Model</span>
                            {sortField === "model" && sortOrder === 1 && (
                              <i
                                className="pi pi-angle-up"
                                style={{ marginLeft: "5px" }}
                              />
                            )}
                            {sortField === "model" && sortOrder === -1 && (
                              <i
                                className="pi pi-angle-down"
                                style={{ marginLeft: "5px" }}
                              />
                            )}
                          </div>
                        }
                        filter
                        filterMatchMode="custom"
                        filterFunction={modelFilterFunction}
                        bodyStyle={{ textAlign: "center" }}
                        style={{ textAlign: "center" }}
                      >
                        <InputText
                          style={{ width: "100%" }}
                          placeholder="Search Model"
                        />
                      </Column>
                      <Column
                        field="bin_no"
                        header={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                            onClick={handleBINSort}
                          >
                            <span className="table-headers">BIN</span>
                            {sortField === "bin_no" && sortOrder === 1 && (
                              <i
                                className="pi pi-angle-up"
                                style={{ marginLeft: "5px" }}
                              />
                            )}
                            {sortField === "bin_no" && sortOrder === -1 && (
                              <i
                                className="pi pi-angle-down"
                                style={{ marginLeft: "5px" }}
                              />
                            )}
                          </div>
                        }
                        filter
                        filterMatchMode="custom"
                        filterFunction={binFilterFunction}
                        bodyStyle={{ textAlign: "center" }}
                        style={{ textAlign: "center" }}
                      >
                        <InputText
                          style={{ width: "100%" }}
                          placeholder="Search BIN"
                        />
                      </Column>
                      <Column
                        field="formatted_date"
                        header={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                            onClick={handleDateSort}
                          >
                            <span className="table-headers">Date</span>
                            {sortField === "formatted_time" &&
                              sortOrder === 1 && (
                                <i
                                  className="pi pi-angle-up"
                                  style={{ marginLeft: "5px" }}
                                />
                              )}
                            {sortField === "formatted_time" &&
                              sortOrder === -1 && (
                                <i
                                  className="pi pi-angle-down"
                                  style={{ marginLeft: "5px" }}
                                />
                              )}
                          </div>
                        }
                        style={{ minWidth: "8rem" }}
                        bodyStyle={{ textAlign: "center" }}
                      />
                      <Column
                        field="shift"
                        header={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                            onClick={handleShiftSort}
                          >
                            <span>Shift</span>
                            {sortField === "shift" && sortOrder === 1 && (
                              <i
                                className="pi pi-angle-up"
                                style={{ marginLeft: "5px" }}
                              />
                            )}
                            {sortField === "shift" && sortOrder === -1 && (
                              <i
                                className="pi pi-angle-down"
                                style={{ marginLeft: "5px" }}
                              />
                            )}
                          </div>
                        }
                        filter
                        filterMatchMode="custom"
                        filterFunction={shiftFilterFunction}
                        bodyStyle={{ textAlign: "center" }}
                        style={{ textAlign: "center" }}
                      >
                        <InputText
                          style={{ width: "100%" }}
                          placeholder="Search Shift"
                        />
                      </Column>
                      <Column
                        field="formatted_time"
                        header={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                            onClick={handleTimeSort}
                          >
                            <span className="table-headers">Scan Time</span>
                            {sortField === "formatted_time" &&
                              sortOrder === 1 && (
                                <i
                                  className="pi pi-angle-up"
                                  style={{ marginLeft: "5px" }}
                                />
                              )}
                            {sortField === "formatted_time" &&
                              sortOrder === -1 && (
                                <i
                                  className="pi pi-angle-down"
                                  style={{ marginLeft: "5px" }}
                                />
                              )}
                          </div>
                        }
                        style={{ minWidth: "8rem" }}
                        bodyStyle={{ textAlign: "center" }}
                      />
                      <Column
                        field="status"
                        header="Status"
                        style={{ minWidth: "8rem" }}
                        body={(rowData) => (
                          <span
                            className={`status-cell  ${getStatusColor(
                              rowData
                            )}`}
                          >
                            {rowData.status === 0 ? "Okay" : "Not Okay"}
                          </span>
                        )}
                        bodyStyle={{ textAlign: "center" }}
                      />
                      {generateViewColumns()}
                    </DataTable>
                  </>
                ) : (
                  <>
                    {" "}
                    <DataTable
                      value={StationWiseData}
                      paginator
                      rows={page_size}
                      className="striped-table table-div "
                      dataKey="id"
                      loading={lazyLoading}
                      header={StationWiseData_lot_header}
                      emptyMessage="No data found."
                      scrollable
                      scrollHeight="550px"
                      removableSort
                      globalFilter={globalFilterValue}
                      // globalFilterFields={["bin"]}
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      totalRecords={totalRecords}
                      // lazy
                      first={first}
                      // onPage={loadCarsLazy}
                      loadingTemplate={loadingTemplate}
                    >
                      <Column
                        field="serial_number"
                        header="Sr. No."
                        // sortable
                        bodyStyle={{ textAlign: "center" }}
                        style={{ minWidth: "6rem" }}
                      />
                      <Column
                        field="model"
                        header={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                            onClick={handleModelSort}
                          >
                            <span className="table-headers">Model</span>
                            {sortField === "model" && sortOrder === 1 && (
                              <i
                                className="pi pi-angle-up"
                                style={{ marginLeft: "5px" }}
                              />
                            )}
                            {sortField === "model" && sortOrder === -1 && (
                              <i
                                className="pi pi-angle-down"
                                style={{ marginLeft: "5px" }}
                              />
                            )}
                          </div>
                        }
                        bodyStyle={{ textAlign: "center" }}
                        style={{ textAlign: "center" }}
                      >
                        <InputText
                          style={{ width: "100%" }}
                          placeholder="Search Model"
                        />
                      </Column>
                      <Column
                        field="bin_no"
                        header={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                            onClick={handleBINSort}
                          >
                            <span className="table-headers">BIN</span>
                            {sortField === "bin_no" && sortOrder === 1 && (
                              <i
                                className="pi pi-angle-up"
                                style={{ marginLeft: "5px" }}
                              />
                            )}
                            {sortField === "bin_no" && sortOrder === -1 && (
                              <i
                                className="pi pi-angle-down"
                                style={{ marginLeft: "5px" }}
                              />
                            )}
                          </div>
                        }
                        // filter
                        // filterMatchMode="custom"
                        // filterFunction={binFilterFunction}
                        bodyStyle={{ textAlign: "center" }}
                        style={{ textAlign: "center" }}
                      >
                        <InputText
                          style={{ width: "100%" }}
                          placeholder="Search BIN"
                        />
                      </Column>
                      <Column
                        field="formatted_date"
                        header={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                            onClick={handleDateSort}
                          >
                            <span className="table-headers">Date</span>
                            {sortField === "formatted_time" &&
                              sortOrder === 1 && (
                                <i
                                  className="pi pi-angle-up"
                                  style={{ marginLeft: "5px" }}
                                />
                              )}
                            {sortField === "formatted_time" &&
                              sortOrder === -1 && (
                                <i
                                  className="pi pi-angle-down"
                                  style={{ marginLeft: "5px" }}
                                />
                              )}
                          </div>
                        }
                        style={{ minWidth: "8rem" }}
                        bodyStyle={{ textAlign: "center" }}
                      />
                      <Column
                        field="shift"
                        header={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                            onClick={handleShiftSort}
                          >
                            <span>Shift</span>
                            {sortField === "shift" && sortOrder === 1 && (
                              <i
                                className="pi pi-angle-up"
                                style={{ marginLeft: "5px" }}
                              />
                            )}
                            {sortField === "shift" && sortOrder === -1 && (
                              <i
                                className="pi pi-angle-down"
                                style={{ marginLeft: "5px" }}
                              />
                            )}
                          </div>
                        }
                        // filter
                        // filterMatchMode="custom"
                        // filterFunction={shiftFilterFunction}
                        bodyStyle={{ textAlign: "center" }}
                        style={{ textAlign: "center" }}
                      >
                        <InputText
                          style={{ width: "100%" }}
                          placeholder="Search Shift"
                          // Add your filter value and onChange handler here
                        />
                      </Column>
                      <Column
                        field="formatted_time"
                        header={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                            }}
                            onClick={handleTimeSort}
                          >
                            <span className="table-headers">Scan Time</span>
                            {sortField === "formatted_time" &&
                              sortOrder === 1 && (
                                <i
                                  className="pi pi-angle-up"
                                  style={{ marginLeft: "5px" }}
                                />
                              )}
                            {sortField === "formatted_time" &&
                              sortOrder === -1 && (
                                <i
                                  className="pi pi-angle-down"
                                  style={{ marginLeft: "5px" }}
                                />
                              )}
                          </div>
                        }
                        style={{ minWidth: "8rem" }}
                        bodyStyle={{ textAlign: "center" }}
                      />
                      <Column
                        field="status"
                        header="Status"
                        style={{ minWidth: "8rem" }}
                        body={(rowData) => (
                          <span
                            className={`status-cell  ${getStatusColor(
                              rowData
                            )}`}
                          >
                            {rowData.status === 0 ? "Okay" : "Not Okay"}
                          </span>
                        )}
                        bodyStyle={{ textAlign: "center" }}
                      />
                      <Column
                        field="result"
                        header="View"
                        style={{ minWidth: "6rem" }}
                        bodyStyle={{ textAlign: "center" }}
                        body={verifiedBodyTemplate}
                      />
                    </DataTable>
                  </>
                )}
              </div>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

export default StationWiseData;
